import { render, staticRenderFns } from "./ItemInventario.vue?vue&type=template&id=3988e431&scoped=true&"
import script from "./ItemInventario.vue?vue&type=script&lang=js&"
export * from "./ItemInventario.vue?vue&type=script&lang=js&"
import style0 from "./ItemInventario.vue?vue&type=style&index=0&id=3988e431&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3988e431",
  null
  
)

export default component.exports